import { GET_ALL_CATEGORIES } from './type';

export function getAllCategories() {
  return (dispatch, getState, { axios }) => {
    dispatch({
      type: GET_ALL_CATEGORIES,
      payload: []
    });
    axios.get(`/v3/categories/find`)
      .then((response) => {
        dispatch({
          type: GET_ALL_CATEGORIES,
          payload: response.data.data
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_ALL_CATEGORIES,
          payload: []
        });
      })
  }
}

// export function getCategoryFirstLevel() {
//   return (dispatch, getState, { axios }) => {
//     dispatch({
//       type: GET_ITEM_CATEGORY_1,
//       payload: []
//     });
//     axios.get(`/v3/cat_1s/find`)
//       .then((response) => {
//         dispatch({
//           type: GET_ITEM_CATEGORY_1,
//           payload: response.data
//         });
//       })
//       .catch((error) => {
//         dispatch({
//           type: GET_ITEM_CATEGORY_1,
//           payload: []
//         });
//       })
//   }
// }

// export function getCategoryChildLevel(cat1_id) {
//   return (dispatch, getState, { axios }) => {
//     dispatch({
//       type: GET_ITEM_CATEGORY_1,
//       payload: []
//     });
//     axios.get(`/v3/cat_1s/find`)
//       .then((response) => {
//         dispatch({
//           type: GET_ITEM_CATEGORY_1,
//           payload: response.data
//         });
//       })
//       .catch((error) => {
//         dispatch({
//           type: GET_ITEM_CATEGORY_1,
//           payload: []
//         });
//       })
//   }
// }